import _ = require('underscore');
import angular = require('angular');
import { EnumService } from '../../../app.common/modules/common/services/enum.service';

interface IStatus {
    status: number;
    class: string;
    title: string;
}

class CampaignStatus {
    static $inject = ['enumService'];
    statusModel: IStatus;
    private status: number;
    private message: string;
    private campaignStatuses: IStatus[];

    constructor(private enumService: EnumService) {
        let running: IStatus = {
            status: enumService.CampaignStatus.Running,
            class: 'bg-success',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Running)
        };

        let draft: IStatus = {
            status: enumService.CampaignStatus.Draft,
            class: 'bg-amber',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Draft)
        };

        let adSubmission: IStatus = {
            status: enumService.CampaignStatus.AdSubmission,
            class: 'bg-amber',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.AdSubmission)
        };

        let qualityControl: IStatus = {
            status: enumService.CampaignStatus.QualityControl,
            class: 'bg-amber',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.QualityControl)
        };

        let archived: IStatus = {
            status: enumService.CampaignStatus.Archived,
            class: 'bg-black',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Archived)
        };

        let completed: IStatus = {
            status: enumService.CampaignStatus.Completed,
            class: 'bg-amber',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Completed)
        };

        let error: IStatus = {
            status: enumService.CampaignStatus.Error,
            class: 'bg-danger tooltip-white tooltip-shops',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Error)
        };

        let disabled: IStatus = {
            status: enumService.CampaignStatus.Disabled,
            class: 'bg-amber',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Disabled)
        };

        let warning: IStatus = {
            status: enumService.CampaignStatus.Warning,
            class: 'bg-warning tooltip-white tooltip-shops',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Warning)
        };

        let scheduled: IStatus = {
            status: enumService.CampaignStatus.Scheduled,
            class: 'bg-warning tooltip-white tooltip-shops',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Scheduled)
        };

        let videoProcessing: IStatus = {
            status: enumService.CampaignStatus.VideoProcessing,
            class: 'bg-warning tooltip-white tooltip-shops',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.VideoProcessing)
        };

        let videoProcessingError: IStatus = {
            status: enumService.CampaignStatus.VideoProcessingError,
            class: 'bg-warning tooltip-white tooltip-shops',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.VideoProcessingError)
        };

        this.campaignStatuses = [running, draft, adSubmission, qualityControl, archived, completed, error, disabled, warning, scheduled, videoProcessing, videoProcessingError];
    }

    $onChanges(changes: any) {
        if (this.status) {
          this.statusModel = _.find(this.campaignStatuses, (item) => {
                return item.status === this.status;
            });
        }
    }

    isShowTooltip() {
        return this.message && !_.isEmpty(this.message);
    }

    getMessage() {
        if (this.message) {
            return `<div>${this.message}</div>`;
        } else {
            return null;
        }
    }
}

angular
    .module('app.retailes.common')
    .component('campaignStatus', {
        template: require('./campaign-status.html'),
        controller: CampaignStatus,
        controllerAs: 'vm',
        bindings: {
            status: '<',
            message: '<'
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/components/campaign-status/campaign-status.component.ts